(() => {
  const experts = [
    {
      key: 'dott filippo pagani',
      id: 'filippo-pagani',
      name: 'Dott. Filippo Pagani',
      shortName: 'Filippo Pagani',
      role: 'Personal trainer e autore di Fisico da Spartano',
    },
    {
      key: 'dott andrea militello',
      id: 'andrea-militello',
      name: 'Dott. Andrea Militello',
      shortName: 'Andrea Militello',
      role: 'Urologo, andrologo e Top Doctor',
    },
    {
      key: 'dott francesco balducci',
      id: 'francesco-balducci',
      name: 'Dott. Francesco Balducci',
      shortName: 'Francesco Balducci',
      role: 'Medico esperto in prevenzione e anti-aging',
    },
    {
      key: 'dott marco franceschin',
      id: 'marco-franceschin',
      name: 'Dott. Marco Franceschin',
      shortName: 'Marco Franceschin',
      role: 'Chirurgo ed esperto nella cura dell’obesità',
    },
    {
      key: 'dott ssa angela cancellara',
      id: 'angela-cancellara',
      name: 'Dott.ssa Angela Cancellara',
      shortName: 'Angela Cancellara',
      role: 'Farmacista esperta in benessere e integrazione',
    },
    {
      key: 'dott michele raganati',
      id: 'michele-raganati',
      name: 'Dott. Michele Raganati',
      shortName: 'Michele Raganati',
      role: 'Farmacista ed esperto di nutrizione sportiva',
    },
    {
      key: 'dott roberto boscia',
      id: 'roberto-boscia',
      name: 'Dott. Roberto Boscia',
      shortName: 'Roberto Boscia',
      role: 'Farmacista ed esperto di nutrizione',
    },
    {
      key: 'marco gandolfi vannini',
      id: 'marco-gandolfi-vannini',
      name: 'Marco Gandolfi Vannini',
      shortName: 'Marco Gandolfi',
      role: 'Coach di campioni e preparatore atletico',
    },
    {
      key: 'alex zuccaro',
      id: 'alex-zuccaro',
      name: 'Alex Zuccaro',
      shortName: 'Alex Zuccaro',
      role: 'Campione IFBB e coach di bodybuilding',
    },
    {
      key: 'alessandra amori',
      id: 'alessandra-amori',
      name: 'Alessandra Amori',
      shortName: 'Alessandra Amori',
      role: 'Personal trainer e coach fitness',
    },
    {
      key: 'elena levaggi',
      id: 'elena-levaggi',
      name: 'Elena Levaggi',
      shortName: 'Elena Levaggi',
      role: 'Atleta Bikini Fitness e coach',
    },
    {
      key: 'nathaly navas',
      id: 'nathaly-navas',
      name: 'Nathaly Navas',
      shortName: 'Nathaly Navas',
      role: 'Insegnante certificata di Yoga',
    },
  ];

  const normalise = (text) =>
    text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('it')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const buildExpertsPage = () => {
    const main = document.querySelector('main');
    if (!main || document.body.classList.contains('spartan-experts-page--ready')) return;

    const headingLookup = new Map(
      Array.from(main.querySelectorAll('h1, h2, h3, h4')).map((heading) => [
        normalise(heading.textContent),
        heading,
      ])
    );
    const presentExperts = experts.filter((expert) => headingLookup.has(expert.key));
    if (!presentExperts.length) return;

    document.body.classList.add('spartan-experts-page', 'spartan-experts-page--ready');

    const heroHeading = Array.from(main.querySelectorAll('h1, h2, h3, h4')).find(
      (heading) =>
        normalise(heading.textContent) === 'esperti' && heading.getBoundingClientRect().height > 0
    );
    const hero = heroHeading && heroHeading.closest('[data-pf-type="FlexBlock"]');

    if (hero) {
      hero.classList.add('spartan-experts-page__hero');
      const heroSection = hero.closest('[data-section-id]');
      if (heroSection) heroSection.classList.add('spartan-experts-page__hero-section');
      heroHeading.textContent = 'I nostri esperti';
      Array.from(hero.querySelectorAll('h1, h2, h3, h4, h5, h6, p')).forEach(
        (element) => {
          if (element !== heroHeading && normalise(element.textContent) === 'i nostri') {
            element.remove();
          }
        }
      );

      if (!hero.querySelector('.spartan-experts-page__intro')) {
        const intro = document.createElement('p');
        intro.className = 'spartan-experts-page__intro';
        intro.textContent =
          'Un team multidisciplinare di medici, farmacisti, coach e atleti unito da un principio: trasformare la scienza in risultati concreti.';
        hero.appendChild(intro);
      }

      const existingNav = document.querySelector('.spartan-experts-page__nav');
      if (existingNav) existingNav.remove();
    }

    presentExperts.forEach((expert, index) => {
      const heading = headingLookup.get(expert.key);
      const copy = heading && heading.closest('[data-pf-type="FlexBlock"]');
      const profile = copy && copy.parentElement;
      const wrap = profile && profile.parentElement;
      const visual =
        profile &&
        Array.from(profile.children).find(
          (child) => child !== copy && child.querySelector('img')
        );

      if (!heading || !copy || !profile || !visual) return;

      heading.id = expert.id;
      heading.textContent = expert.name;
      profile.classList.add('spartan-expert-profile');
      copy.classList.add('spartan-expert-profile__copy');
      visual.classList.add('spartan-expert-profile__visual');
      if (wrap) wrap.classList.add('spartan-expert-profile-wrap');
      const profileSection = profile.closest('[data-section-id]');
      if (profileSection) {
        profileSection.classList.add('spartan-experts-page__profiles-section');
      }
      if (index % 2 === 1) profile.classList.add('spartan-expert-profile--reverse');

      let role = copy.querySelector('.spartan-expert-profile__role');
      if (!role) {
        role = document.createElement('span');
        role.className = 'spartan-expert-profile__role';
        heading.insertAdjacentElement('beforebegin', role);
      }
      role.textContent = expert.role;

      let bio = copy.querySelector('.spartan-expert-profile__bio');
      if (!bio) {
        bio = document.createElement('div');
        bio.className = 'spartan-expert-profile__bio';

        Array.from(copy.children)
          .filter(
            (child) =>
              child !== heading &&
              child !== role &&
              !child.classList.contains('spartan-expert-profile__toggle')
          )
          .forEach((child) => bio.appendChild(child));
        copy.appendChild(bio);
      }

      copy.querySelectorAll('.spartan-expert-profile__toggle').forEach((toggle) => {
        toggle.remove();
      });
    });

    const scrollToHash = () => {
      if (!window.location.hash) return;
      const target = document.getElementById(window.location.hash.slice(1));
      if (target) target.scrollIntoView({ block: 'start' });
    };

    requestAnimationFrame(scrollToHash);
    window.setTimeout(scrollToHash, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildExpertsPage, { once: true });
  } else {
    buildExpertsPage();
  }

  window.setTimeout(buildExpertsPage, 700);
})();
